import React, { useEffect, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap'
import { UrlEncodeHook } from '../../hooks'
import { get, post } from '../../helpers/api_helper'

import { useSelector } from 'react-redux'
import * as validation from '../../helpers/validation'
import * as Util from '../../helpers/utils'
import { toast } from 'react-toastify'
import GRecaptcha from '../../components/GRecaptcha'
const AnimalContact = () => {
  const { urlDecode } = UrlEncodeHook()
  let { ID } = useParams()
  ID = urlDecode(ID)
  const history = useHistory()
  const [userDetail, setUserDetail] = useState({})

  const [breedData, setbreedData] = useState({})

  //
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [description, setDescription] = useState('')
  const [error, setError] = useState({})
  const [GRC, setGRC] = useState(null)

  //

  useEffect(() => {
    get(
      `/api/v1/admin/easyfied/sales-services-judge/one/${ID}?with_owner_details=1`
    ).then((res) => {
      setUserDetail(res.data)
    })
  }, [])

  const onSubmit = async () => {
    const token = await GRC.current.executeAsync()
    let validationFlag = false
    let err = {}
    if (!name.trim()) {
      validationFlag = true
      err.name = `Name ${validation.REQUIRED}`
    }
    if (name.trim()) {
      if (!Util.ONLY_CHAR_REGEX.test(name.trim())) {
        validationFlag = true
        err.name = `Name ${validation.ONLY_CHARACTER_AND_HYPHEN}`
      } else if (name.trim().length >= 50) {
        validationFlag = true
        err.name = `Name ${validation.MAX_CHAR_FUN(50)}`
      }
    }
    if (!email.trim()) {
      validationFlag = true
      err.email = `Email ${validation.REQUIRED}`
    }
    if (email.trim()) {
      if (!Util.EMAIL_REGEX.test(email.trim())) {
        validationFlag = true
        err.email = `Email ${validation.INVALID}`
      }
    }
    if (!description.trim()) {
      validationFlag = true
      err.description = `Message ${validation.REQUIRED}`
    }
    if (description.trim()) {
      if (description.trim().length >= 1000) {
        validationFlag = true
        err.description = `Message ${validation.MAX_CHAR_FUN(1000)}`
      }
    }
    setError(err)
    if (!validationFlag && token) {
      let obj = {
        sales_service_id: ID,
        req_user_name: name.trim(),
        req_user_email: email.trim(),
        description: description.trim(),
        breed_name: breedData?.breed_name,
        user_id: userDetail?.owner_details?.id,
        display_name: userDetail?.display_name || '',
        serve_as_judge: userDetail?.serve_as_judge || '',
        serve_as_registrar: userDetail?.serve_as_registrar || '',
        cavy_judge: userDetail?.cavy_judge || '',
        rabbit_judge: userDetail?.rabbit_judge || '',
        travel_radius: userDetail?.title || '',
      }
      document.getElementById('submit-btn').setAttribute('disabled', true)
      post(`/api/v1/admin/easyfied/sales-services-judge/create-contact-us`, obj)
        .then((res) => {
          // document.getElementById('submit-btn').removeAttribute('disabled')
          if (res.data) {
            setName('')
            setEmail('')
            setDescription('')
            toast.success(res.data)
            history.push('/easyfides/judges')
          }
        })
        .catch((err) => {
          document.getElementById('submit-btn').removeAttribute('disabled')
          if (err?.response?.data) {
            toast.error(err?.response?.data)
          }
        })
    }
  }

  return (
    <section
      className='section bg-gray-101 pages event-list mt-12'
      style={{ minHeight: '100vh' }}
    >
      <Container fluid>
        <div className='row mb-6'>
          <Col md={6} sm={6} xs={6}>
            <h2 className='top-title'>
              <span>Contact</span>
            </h2>
          </Col>
          <Col md={6} sm={6} xs={6} className='text-end'>
            <Link to='/easyfides/judges' title='Back'>
              <Button color='primary'>BACK</Button>
            </Link>
          </Col>
        </div>
        <div className='col-md-12 mt-3'>
          <p>
            Easyfieds will send your request to the listing person and that
            person will respond directly to you at the email listed below. If
            the listing person’s contact information is visible, you may choose
            to contact them through the Easyfied contact request or directly.
          </p>
        </div>
        <Row>
          <Col
            md={12}
            xs={12}
            sm={12}
            className='d-flex1 justify-content-center form-cont-label'
          >
            <Row>
              <Col md={12} xs={12} sm={12}>
                <Card>
                  <CardBody>
                    <div className='p-6'>
                      <div className='pb-3'>
                        <h3 className='mb-3'>
                          Registrars & Judges - Contact Request
                        </h3>
                      </div>

                      <Row>
                        <Col md={12} sm={12} xs={12} className='m-auto'>
                          <Row>
                            <Col md={12} sm={12} className='mb-3'>
                              <Label>Please enter your information</Label>
                            </Col>
                            <Col md={12} sm={12}>
                              <FormGroup className='mb-2'>
                                <Label htmlFor='name'>Name *</Label>
                                <Input
                                  type='text'
                                  name='name'
                                  id='name'
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  placeholder='Name'
                                />
                                {error?.name ? (
                                  <div className='text-danger mt-1'>
                                    {error?.name}
                                  </div>
                                ) : null}
                              </FormGroup>
                              <FormGroup className='mb-2'>
                                <Label htmlFor='email'>Email *</Label>
                                <Input
                                  type='email'
                                  name='email'
                                  id='email'
                                  value={email}
                                  placeholder='Email'
                                  onChange={(e) => setEmail(e.target.value)}
                                />
                                {error?.email ? (
                                  <div className='text-danger mt-1'>
                                    {error?.email}
                                  </div>
                                ) : null}
                              </FormGroup>
                            </Col>

                            <FormGroup className='my-3'>
                              <Label htmlFor='Description' className='d-block'>
                                Message *
                              </Label>
                              <Input
                                id='Description'
                                name='Description'
                                value={description}
                                placeholder='Message'
                                type='textarea'
                                rows='4'
                                onChange={(e) => setDescription(e.target.value)}
                              />
                              <div className='text-muted'>{`(Note: Do not use <, >, ', ")`}</div>
                              {error?.description ? (
                                <div className='text-danger mt-1'>
                                  {error?.description}
                                </div>
                              ) : null}
                            </FormGroup>

                            <Col md={12} xs={12} className='mb-2 mt-3'>
                              <p className='text-black'>
                                {`I am interested in  ${
                                  userDetail?.display_name || ''
                                }`}
                              </p>
                            </Col>

                            {userDetail?.owner_details?.alias_name_easyfied &&
                            userDetail?.owner_details?.email ? (
                              <div className='col-md-12 col-xs-12'>
                                <p className='text-black'>
                                  <strong>Name : </strong>
                                  <span>
                                    {userDetail?.owner_details
                                      ?.alias_name_easyfied || ''}
                                  </span>
                                </p>{' '}
                                <p className='text-black'>
                                  <strong>Email : </strong>
                                  <span>
                                    {' '}
                                    <a
                                      href={`mailto:${userDetail?.owner_details?.email}`}
                                    >
                                      {userDetail?.owner_details?.email}
                                    </a>{' '}
                                  </span>
                                </p>
                              </div>
                            ) : null}
                            <div
                              className='col-md-12 pt-2 text-left mt-4'
                              title='Submit'
                            >
                              <Button
                                size='lg'
                                id='submit-btn'
                                onClick={onSubmit}
                              >
                                SUBMIT
                              </Button>
                            </div>
                          </Row>
                        </Col>
                        <GRecaptcha setGRC={setGRC} />
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AnimalContact

// let Category = [
//   {
//     breed_category_id: 1,
//     category_name: 'Rabbit Breed List',
//   },
//   {
//     breed_category_id: 2,
//     category_name: 'Cavy Breed List',
//   },
//   {
//     breed_category_id: 3,
//     category_name: 'Exhibition Breed List',
//   },
//   {
//     breed_category_id: 4,
//     category_name: 'Commercial Breed List',
//   },
// ]
